import DialogTitle from "@material-ui/core/DialogTitle";
import MuiIconButton from "@material-ui/core/IconButton";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import CloseIcon from "@material-ui/icons/Close";
import React from "react";
const useStyles = makeStyles((theme) => ({
    root: {
        minWidth: 300,
    },
    title: {
        fontWeight: 600,
    },
    closeButton: {
        position: "absolute",
        right: theme.spacing(1),
        top: theme.spacing(1),
    },
}));
const DialogHeader = ({ onClose, isMobileView, hideCloseIcon, children, }) => {
    const classes = useStyles({ isMobileView });
    return (React.createElement(DialogTitle, { className: classes.root, disableTypography: true },
        React.createElement(Typography, { variant: "h3", className: classes.title }, children),
        !hideCloseIcon && (React.createElement(MuiIconButton, { "data-cy": "ui-modal-close-button", className: classes.closeButton, "aria-label": "close", onClick: onClose },
            React.createElement(CloseIcon, null)))));
};
DialogHeader.defaultProps = {
    hideCloseIcon: false,
};
export default DialogHeader;
//# sourceMappingURL=Header.js.map